import { FailedResponse } from '@citrite/http';

export class AiTaskInitiationError extends Error {
	public constructor(public cause?: unknown, public name = 'AiTaskInitiationError') {
		super('Failed to start AI generation task');
	}

	public isRateLimitError(): boolean {
		const cause = this.cause as FailedResponse;
		if (!!cause && !!cause.status && cause.status === 429) {
			return true;
		}
		return false;
	}

	public isInaccessibleResourceError(): boolean {
		const cause = this.cause as FailedResponse;
		if (!!cause && !!cause.status && cause.status === 403) {
			return true;
		}
		return false;
	}
}
